// extracted by mini-css-extract-plugin
export default {"TitleSwitch":"TitleSwitch_TitleSwitch__9nvLx"};